import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PricePerAcreTag } from './styled';
import { roundNumber } from '../../../../../utils/helpers/common';

interface PricePerAcreProps {
  area?: string;
  price?: string;
}

export const PricePerAcre: React.FC<PricePerAcreProps> = ({ area, price }) => {
  const { t } = useTranslation();
  const areaNum = Number(area);
  const priceNum = Number(price);
  const pricePerAcre = useMemo(() => {
    if (!areaNum || !priceNum) return 0;
    return roundNumber(priceNum / areaNum);
  }, [areaNum, priceNum]);

  return (
    <PricePerAcreTag tag="body_3" data-cy="create-item-price-per-acre-prompt">
      {(!area && price) || area === '0'
        ? t('new_ad.price_per_sot_empty')
        : t('new_ad.price_per_sot', { price: pricePerAcre })}
    </PricePerAcreTag>
  );
};
